import React from 'react';
import { Button, IconButton, Tooltip } from '@mui/material';
import { isReadOnlyAdmin } from '../../hooks/useReadOnlyMode';

const READ_ONLY_MSG = "Read-only access — you don't have permission to make changes.";

// Wraps a control so it is disabled with an explanatory tooltip in read-only mode.
// A disabled MUI control swallows hover events, so the tooltip wraps a <span>.
const withReadOnly = (children) => {
  if (!isReadOnlyAdmin()) return children;
  return (
    <Tooltip title={READ_ONLY_MSG}>
      <span>{children}</span>
    </Tooltip>
  );
};

// Drop-in replacement for MUI <Button> that disables + tooltips in read-only mode.
export const ReadOnlyButton = ({ disabled, children, ...props }) => {
  const ro = isReadOnlyAdmin();
  return withReadOnly(
    <Button disabled={disabled || ro} {...props}>{children}</Button>
  );
};

// Drop-in replacement for MUI <IconButton>.
export const ReadOnlyIconButton = ({ disabled, children, ...props }) => {
  const ro = isReadOnlyAdmin();
  return withReadOnly(
    <IconButton disabled={disabled || ro} {...props}>{children}</IconButton>
  );
};

export default ReadOnlyButton;
